import { Component, effect, ElementRef, output, signal, viewChild, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChatInputComponent } from '../chat-input/chat-input.component';
import { NzRowDirective } from 'ng-zorro-antd/grid';
import { IChatInput } from '../../interfaces/chat-response.interface';
import { marked } from 'marked';
import DOMPurify from 'dompurify';
import {ChatbotThemeService} from "../../services/theme.service";

@Component({
  selector: 'chatbot-component',
  standalone: true,
  imports: [CommonModule, NzRowDirective, ChatInputComponent],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.less',
})
export class ChatComponent {
  private readonly _chatHistory = viewChild.required<ElementRef>('chatHistory');
  input = viewChild.required<ChatInputComponent>('input');
  isWidgetMode = input<boolean>(false);
  message = output<string>();
  messages = signal<IChatInput[]>([{ message: 'Salut! Cu ce te pot ajuta azi?', isBot: true }]);
  isLoading = signal<boolean>(false);

  constructor(private readonly _themeService: ChatbotThemeService) {
  }

  sendChatMessage(event: IChatInput) {
    this._updateMessages(event.message, event.isBot);
  }

  getImageUrlFromCdnUrl() {
    return `${this._themeService.BASE_ASSETS_URL}/assets/logo-${this._themeService.currentTheme}.png`;
  }

  onLoadingChange(event: boolean) {
    this.isLoading.set(event);
  }

  renderChatMessage(input: IChatInput): string {
    const formattedMessage = marked.parse(input.message, { async: false }) as string;
    return DOMPurify.sanitize(formattedMessage);
  }

  private readonly autoScrollEffect = effect(() => {
    this.messages();
    setTimeout(() => this._scrollToBottom(), 0);
  });

  private _scrollToBottom(): void {
    try {
      const chatElement = this._chatHistory();
      if (chatElement?.nativeElement) {
        chatElement.nativeElement.scrollTop = chatElement.nativeElement.scrollHeight;
      }
    } catch (err) {
      console.error('Failed to scroll chat history:', err);
    }
  }

  private _updateMessages(message: string, isBot: boolean) {
    this.messages.update((messages) => {
      const updated = [...messages];
      if (!isBot) {
        // Always push user messages as new entries
        updated.push({ message, isBot });
        return updated;
      }

      // For bot messages: update last bot message if present, else create a new one
      const last = updated[updated.length - 1];
      if (last?.isBot) {
        last.message = message;
      } else {
        updated.push({ message, isBot: true });
      }
      return updated;
    });
  }
}
